/**
 * The model trains on a window of days, not a single end date. Prefer the
 * server's start when it sends one; otherwise walk back from dataThrough.
 */
export function formatTrainingWindow(
  dataThrough: string | null,
  trainingDays: number,
  dataFrom?: string | null
): string {
  if (dataFrom && dataThrough) {
    return dataFrom === dataThrough
      ? dataThrough
      : `${dataFrom} – ${dataThrough}`;
  }

  if (dataThrough && trainingDays >= 1) {
    const start = addUtcDays(dataThrough, -(trainingDays - 1));
    return start === dataThrough ? dataThrough : `${start} – ${dataThrough}`;
  }

  return dataThrough ?? "—";
}

export function addUtcDays(isoDate: string, days: number): string {
  const [year, month, day] = isoDate.split("-").map(Number);
  const utc = Date.UTC(year, month - 1, day + days);
  return new Date(utc).toISOString().slice(0, 10);
}

/** True once the stored model is newer than the rebuild click. */
export function hasModelMovedPastQueue(
  lastTrainedAt: string | null,
  queuedAt: string
): boolean {
  if (!lastTrainedAt) return false;
  return new Date(lastTrainedAt).getTime() > new Date(queuedAt).getTime();
}
